import Backbone from 'backbone'
import template from './edit-form.hbs'
import footerEditButtonContainer from './footer-edit-button-container.hbs'
import EditButtons from './edit-buttons'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import _ from 'lodash'
import TemplateNamingPanel from 'scoreboard/templates/template-naming-panel-contents'
import prefixSuffix from 'scoreboard/templates/prefix-suffix'
import i18n from 'scoreboard/components/i18n'
import BoxOptions from 'scoreboard/components/box-options'
import $ from 'jquery'
import { isV5, isV6 } from 'scoreboard/components/version'

var EditForm = Backbone.View.extend({

	// this.model is a domain object, such as a document

	tagName: 'form',

	/**
	 * Initializes with the following options:
	 *
	 * section (required) - the current section
	 * model (required) - the model
	 */
	className: 'edit-form',

	/**
	 * @param {Object} options
	 *
	 * @param {String} [options.deleteExtraBannerMessage]
	 * See documentation for options.extraBannerMessage in delete-confirmation.js
	 *
	 * @param {jQuery} [options.advancedLayoutOptions] the element that's appended to the
	 * 												   bottom of the form, containing the
	 * 												   form's content.
	 * @param {Object} [options.validator] one or more validators to append
	 * to the validators for the label field
	 *
	 * @param {Boolean} [options.hideFormContent=false] if true, the form content will
	 * be hidden. This allows us to only show the advanced options if needed.
	 */
	initialize: function(options) {
		this.options = options
	},

	render: function() {
		if (isV5()) {
			this.$el.addClass('panel')
		}
		this.buttons = new EditButtons(this.options).render()
		this.buttons.on('deleted', this.trigger.bind(this, 'deleted'))
		this.$el.empty().append(template(_.defaults({
			layoutOptions: _.get(this.options, 'layoutOptions.length'),
			advancedLayoutOptions: this.options.advancedLayoutOptions,
			layoutInstructions: this.options.layoutInstructions,
			hideFormContent: this.options.hideFormContent
		}, this.model.attributes)))

		if (this.options.advancedLayoutOptions) {
			this.$('.advanced-layout-options').append(this.options.advancedLayoutOptions)
			this.$el.closest('.display-pane-body').after(footerEditButtonContainer())

			this.buttons.$el.addClass('edit-buttons-bottom')
			$('.edit-buttons-container').append(this.buttons.el)
			this.buttons.on('save', this.trigger.bind(this, 'save'))
			this.buttons.on('cancel', this.trigger.bind(this, 'cancel'))
		}

		if (this.options.layoutOptions) {
			this.layoutOptions = new BoxOptions({ availableOptions: this.options.layoutOptions }).render()
			if (isV5()) {
				this.$('.layout-options').after(this.layoutOptions.el)
			}
			if (isV6()) {
				this.$('.layout-options').append(this.layoutOptions.el)
			}
		}
		this.$('.edit-buttons').replaceWith(this.buttons.el)
		if (isV6()) {
			if (!this.options.advancedLayoutOptions) {
				this.buttons.$el.addClass('edit-buttons-bottom')
			}
		}

		if (this.model.get('templateId')) {
			// If this is a template copy, can't directly edit the label
			this.$('.edit-form-label').addClass('is-not-displayed')

			if (!this.model.get('organizationIsCopy')) {
				// If this is a standalone copy (ie not a copy inside an organization copy),
				// we can edit the prefix and suffix
				var rollupTreeGroupLabel = this.model.get('template').label
				var presuff = prefixSuffix.get(
					rollupTreeGroupLabel, this.model.get('label')
				)

				this.templateNaming = new TemplateNamingPanel({
					section: this.options.section,
					rollupTreeGroupLabel: rollupTreeGroupLabel,
					prefix: presuff.prefix,
					suffix: presuff.suffix,
					inputLabels: {
						prefix: i18n.get('template.titlePrefix'),
						suffix: i18n.get('template.titleSuffix'),
						example: i18n.get('template.preview')
					}
				})

				this.$('.edit-form-label').after(this.templateNaming.el)
				this.templateNaming.render()
			}
		} else {
			this.setUpMarkedField()
		}

		return this
	},

	setUpMarkedField: function(labelInput) {
		this.labelInput = labelInput || this.$('[name=label]')
		// If this isn't a template copy, we can directly edit the label
		// #51483 add any extra validator(s) to the labelField validators
		// (ex. a length requirement validator)
		let validators = [requiredValidator]
		if (this.options.validator) {
			validators = [...validators, ..._.castArray(this.options.validator)]
		}
		this.labelField = new MarkedField({
			el: this.labelInput,
			validators
		}).render()
	},

	val: function () {
		if (this.model.get('templateId')) {
			return this.model.get('organizationIsCopy') ? this.model.get('label') : this.templateNaming.label()
		} else {
			return this.labelInput.val()
		}
	},

	removeLayoutOptions: function() {
		this.$('.layout-options, .layout-instructions').remove()
		this.options.layoutOptions = null
		this.options.layoutInstructions = null
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.buttons, this.labelField, this.templateNaming], 'remove')
	}

})

export default EditForm

EditForm.__filename__ = 'components/edit/edit-form.js'
